// extracted by mini-css-extract-plugin
module.exports = {"licenseExpirationModal":"GlobalModalContainer_licenseExpirationModal__7SSwZ"};